<template>
  <!-- 增加修改 -->
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('system.nickName')" prop="nickName">
        <a-input v-model="form.nickName" :placeholder="$t('common.input')" :maxLength="30" />
      </a-form-model-item>
<!--      <a-form-model-item label="部门" prop="deptId">-->
<!--        <a-tree-select-->
<!--          v-model="form.deptId"-->
<!--          style="width: 100%"-->
<!--          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"-->
<!--          :tree-data="deptOptions"-->
<!--          placeholder="请选择"-->
<!--          :replaceFields="replaceFields"-->
<!--          tree-default-expand-all-->
<!--        >-->
<!--        </a-tree-select>-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('system.phoneNumber')" prop="phoneNumber">
        <a-input v-model="form.phoneNumber" :placeholder="$t('common.input')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('system.email')" prop="email">
        <a-input v-model="form.email" :placeholder="$t('common.input')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('system.userName')" prop="userName" v-if="form.id == undefined">
        <a-input v-model="form.userName" :placeholder="$t('common.input')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('system.password')" prop="password" v-if="form.id == undefined">
        <a-input-password v-model="form.password" :placeholder="$t('common.input')" :maxLength="20" />
      </a-form-model-item>
<!--      <a-form-model-item label="性别" prop="sex">-->
<!--        <a-radio-group v-model="form.sex" button-style="solid">-->
<!--          <a-radio-button v-for="(d, index) in sexOptions" :key="index" :value="parseInt(d.value)">{{ d.label }}</a-radio-button>-->
<!--        </a-radio-group>-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('system.status')" prop="status">
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button v-for="(d, index) in statusOptions" :key="index" :value="parseInt(d.value)">{{ getStatusLabel(d.value) }}</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
<!--      <a-form-model-item label="岗位" prop="postIds">-->
<!--        <a-select-->
<!--          mode="multiple"-->
<!--          v-model="form.postIds"-->
<!--          placeholder="请选择"-->
<!--        >-->
<!--          <a-select-option v-for="(d, index) in postOptions" :key="index" :value="d.id">-->
<!--            {{ d.postName }}-->
<!--          </a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('system.role')" prop="roleIds">
        <a-select
          mode="multiple"
          v-model="form.roleIds"
          :placeholder="$t('system.selectPlaceholder')"
        >
          <a-select-option v-for="(d, index) in roleOptions" :key="index" :value="d.id">
            {{ d.roleName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('system.remark')" prop="remark">
        <a-input v-model="form.remark" :placeholder="$t('common.input')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import { getUser, addUser, updateUser } from '@/api/system/user'

export default {
  name: 'CreateForm',
  props: {
    deptOptions: {
      type: Array,
      required: true
    },
    statusOptions: {
      type: Array,
      required: true
    },
    sexOptions: {
      type: Array,
      required: true
    }
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      replaceFields: { children: 'children', title: 'label', key: 'id', value: 'id' },
      // 岗位选项
      postOptions: [],
      // 角色选项
      roleOptions: [],
      // 默认密码
      initPassword: undefined,
      // 表单参数
      form: {
        id: undefined,
        deptId: 100,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phoneNumber: undefined,
        email: undefined,
        sex: 0,
        status: 1,
        remark: undefined,
        postIds: [],
        roleIds: []
      },
      open: false
    }
  },
  filters: {
  },
  created () {
    this.getConfigKey('sys.user.initPassword').then(response => {
      this.initPassword = response.msg
    })
  },
  computed: {
    formTitle() {
      return this.form.id !== undefined ? this.$t('system.editUser') : this.$t('system.addUser')
    },
    rules() {
      return {
        userName: [
          { required: true, message: this.$t('system.userNameRequired') }
        ],
        nickName: [
          { required: true, message: this.$t('system.nickNameRequired') }
        ],
        deptId: [
          { required: true, message: this.$t('system.deptRequired'), trigger: 'change' }
        ],
        password: [
          { required: true, message: this.$t('system.passwordRequired') },
          { min: 5, max: 20, message: this.$t('system.passwordLength') }
        ]
      }
    }
  },
  watch: {
  },
  methods: {
    /**
     * 获取状态的国际化标签
     * @param {string|number} value - 状态值
     * @returns {string} 国际化后的状态文本
     */
    getStatusLabel(value) {
      const statusValue = parseInt(value)
      // 0=正常/启用, 1=停用/禁用
      return statusValue === 0 ? this.$t('system.enable') : this.$t('system.disable')
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        id: undefined,
        deptId: 100,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phoneNumber: undefined,
        email: undefined,
        sex: 0,
        status: 1,
        remark: undefined,
        postIds: [],
        roleIds: []
      }
    },
     /** 新增按钮操作 */
    handleAdd () {
      this.reset()
      this.$emit('select-tree')
      getUser().then(response => {
        this.postOptions = response.data.posts
        this.roleOptions = response.data.roles
        this.open = true
        this.form.password = this.initPassword
      })
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.$emit('select-tree')
      const userId = row ? row.id : ids
      getUser(userId).then(response => {
        this.form = response.data.data
        this.postOptions = response.data.posts
        this.roleOptions = response.data.roles
        this.form.postIds = response.data.postIds
        this.form.roleIds = response.data.roleIds
        this.open = true
        this.form.password = undefined
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form)
      // return;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            updateUser(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addUser(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
